import { Colors } from "../../components/ui-library/design-tokens/colors";

export const getTrendColor = (value?: number | null) => {
  if (!value) {
    return Colors.Black;
  }

  return value > 0 ? Colors.Green : Colors.Red;
};
